import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-details-item',
    templateUrl: './details-item.component.html',
    styleUrls: [
        './details-item.component.scss'
    ],
    standalone: false
})
export class DetailsItemComponent
{
    /**
     * A font awesome css classname icon, Ex: 'fa-user'
     */
    @Input() icon: string = 'fa';
    @Input() value: string;
    @Input() keyTrad: string;
}
